module.exports = __webpack_public_path__ + "videos/esfira-desk.a758bb5.mp4";